import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";

import Home from "./components/Home";
import ApkDetails from "./components/ApkDetails";
import AdminLogin from "./components/AdminLogin";
import Blog from "./components/Blog";

import CookieConsent from "react-cookie-consent";

import HowToInstallApk2026 from "./blog/HowToInstallApk2026";
import BestOpenSourceApps2026 from "./blog/BestOpenSourceApps2026";
import BestAndroidFileManagers2026 from "./blog/BestAndroidFileManagers2026";
import BestVPNApps2026 from "./blog/blog-vpn-2026";

import FAQ from "./pages/FAQ";
import SecurityTrust from "./pages/SecurityTrust";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DMCA from "./pages/DMCA";
import NotFound from "./pages/NotFound";
import FakeChat from "./pages/FakeChat";
import AIPhraser from "./pages/AIPhraser";  

const BlogPost = lazy(() => import("./components/BlogPost"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard"));
const CategoryPage = lazy(() => import("./components/CategoryPage"));

function App() {
  return (
    <HelmetProvider>
      <Router>
      <main>


  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/apk/:slug" element={<ApkDetails />} />
    <Route path="/admin" element={<AdminLogin />} />

            <Route path="/blog" element={<Blog />} />
            <Route
              path="/blog/how-to-install-apk-files-android-2026"
              element={<HowToInstallApk2026 />}
            />
            <Route
              path="/blog/best-vpn-apps-for-android-2026"
              element={<BestVPNApps2026 />}
            />
            <Route
              path="/blog/best-open-source-android-apps-2026"
              element={<BestOpenSourceApps2026 />}
            />
            <Route
              path="/blog/best-android-file-managers-2026"
              element={<BestAndroidFileManagers2026 />}
            />

            <Route
              path="/blog/:slug"
              element={
                <Suspense fallback={<div className="page-loading">Loading...</div>}>
                  <BlogPost />
                </Suspense>
              }
            />

            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/security-trust" element={<SecurityTrust />} />
            <Route path="/dmca" element={<DMCA />} />

            {/* TOOLS - FREE VIRAL TOOLS */}
            <Route path="/fake-chat-generator" element={<FakeChat />} />
            <Route path="/ai-paraphrase-tool" element={<AIPhraser />} />

            <Route
              path="/admin/dashboard"
              element={
                <Suspense fallback={<div className="page-loading">Loading...</div>}>
                  <AdminDashboard />
                </Suspense>
              }
            />

            <Route
              path="/:categorySlug"
              element={
                <Suspense fallback={<div className="page-loading">Loading...</div>}>
                  <CategoryPage />
                </Suspense>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <CookieConsent
          location="bottom"
          buttonText="Accept"
          cookieName="alphaapkstoreConsent"
          expires={150}
          style={{ background: "#111827", fontSize: "14px" }}
          buttonStyle={{
            background: "#3b82f6",
            color: "#fff",
            fontSize: "14px",
            borderRadius: "6px",
          }}
        >
          Alpha APK Store™ uses cookies to improve user experience, analytics,
          login features, and website performance. Read our{" "}
          <a
            href="/privacy-policy"
            style={{ color: "#93c5fd", textDecoration: "underline" }}
          >
            Privacy Policy
          </a>.
        </CookieConsent>
      </Router>
    </HelmetProvider>
  );
}

export default App;